import * as cpf from '@fnando/cpf'
import * as cnpj from '@fnando/cnpj'

const validator = {
  /**
   * Valida se um valor é do tipo CPF ou CNPJ
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    return cnpj.isValid(value, true) || cpf.isValid(value, true)
  }
}

export default validator
